<template>
  <v-form ref="form" v-model="formValid" validate-on="input lazy" @submit.prevent>
    <v-text-field
      v-model="localValue.ip"
      variant="outlined"
      class="mb-2"
      :rules="[ipAddressRule]"
      :label="$t(`modals.addCustomDomainDns.ip`)"
      :aria-label="$t(`modals.addCustomDomainDns.ip`)"
      :placeholder="$t(`modals.addCustomDomainDns.ip`)"
    />
    <v-text-field
      v-model="localValue.domain"
      variant="outlined"
      :rules="[domainRule]"
      :label="$t(`modals.addCustomDomainDns.domain`)"
      :aria-label="$t(`modals.addCustomDomainDns.domain`)"
      :placeholder="$t(`modals.addCustomDomainDns.domain`)"
    />
  </v-form>
</template>

<script lang="ts">
import { defineComponent, ref, type PropType, watch } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module.ts";
import Patterns from "@/constants/patterns.ts";
import { useI18n } from "vue-i18n";
import type { VuetifyFormRef } from "@/types.ts";

export default defineComponent({
  emits: ["update:localValue", "update:valid", "update:errors"],
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  setup(_, { emit }) {
    const form = ref<VuetifyFormRef>();
    const { t } = useI18n();
    const localValue = ref({
      ip: "",
      domain: "",
    });
    const formValid = ref(true);

    const ipAddressRule = (value: string) => {
      if (!value) return t("validations.required");
      if (!Patterns.IP_V4.test(value)) {
        return t("validations.ipAddress");
      }
      return true;
    };

    const domainRule = (value: string) => {
      if (!value) return t("validations.required");
      if (!Patterns.DOMAIN.test(value)) {
        return t("validations.domain");
      }
      return true;
    };

    const validate = async () => {
      const { valid } = (await form.value?.validate()) ?? { valid: false };
      return valid;
    };

    watch(
      () => localValue.value,
      () => {
        emit("update:localValue", {
          ...localValue.value,
        });
      },
      { deep: true }
    );

    watch(formValid, (val) => {
      if (val) {
        emit("update:valid", formValid.value);
      }
    });

    return {
      localValue,
      formValid,
      ipAddressRule,
      form,
      validate,
      domainRule,
    };
  },
});
</script>

<style scoped lang="scss"></style>
